/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
*/

export default `
<path d="M0 0h24v24H0z" fill="none"/><path d="M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z"/>
`;
